import React from "react";
import Head from "next/head";

import Terms from "@/components/insureshield/terms";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const InsureShieldTerms = () => {
  return (
    <>
      <Head>
        <title>{seoData.INSURESHIELD_TERMS.title}</title>
        <SeoMetaData data={seoData.INSURESHIELD_TERMS} />
      </Head>

      <Terms />
    </>
  );
};

export default InsureShieldTerms;
